<template>
  <v-container fluid>
    <v-dialog
      v-model="dialog"
      scrollable
      :overlay="false"
      max-width="1200px"
      transition="dialog-transition"
      persistent
    >
      <component
        v-if="dialog"
        :is="'wholesaleDetail'"
        ref="detail"
        :wholesaler="selected"
        @saved="onSaved"
        @closed="dialog = false"
      ></component>
    </v-dialog>
    <v-card>
      <v-card-title>
        <v-title>OPTUS MOBILE DATA NOTIFICATIONS (VIA MUR FILES)</v-title>
      </v-card-title>
      <v-card-text>
        <v-layout fluid>
          <v-flex xs12>
            <wholesale-contacts></wholesale-contacts>

            <ag-grid-vue
              v-if="rowData"
              style="height: 54vh"
              class="ag-theme-balham mb-4"
              @grid-ready="onGridReady"
              @rowSelected="getSelectedRows()"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              rowSelection="single"
              :rowData="rowData"
            ></ag-grid-vue>
          </v-flex>
        </v-layout>
      </v-card-text>
      <div v-if="allFlags.SOG4287">
        <v-card-title>
          <v-title>Rate Plans</v-title>
        </v-card-title>
        <v-card-text>
          <v-layout fluid>
            <v-flex xs12>
              <ratePlan></ratePlan>
            </v-flex>
          </v-layout>
          <message-alert :component="message"></message-alert>
        </v-card-text>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { AgGridVue } from 'ag-grid-vue';
import { HTTP } from '@/http-common';
import wholesaleDetail from '@/components/wholesaler/wholesaleDetail';
import wholesaleContacts from '@/components/wholesaler/WholesalerContacts';
import ratePlan from '@/components/wholesaler/RatePlan.vue'
import { mapRatePlanFields } from '../store/modules/orders';

const { mapGetters: mapFeatureFlagGetters } =
  createNamespacedHelpers(`orders/featureFlag`);

export default {
  name: 'Wholesalers',
  components: {
    AgGridVue,
    wholesaleDetail,
    wholesaleContacts,
    ratePlan
  },

  data() {
    return {
      dialog: false,
      gridOptions: null,
      columnDefs: null,
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
      },
      gridApi: null,
      rowData: [],
      selected: {},
    };
  },
  computed: {
    ...mapFeatureFlagGetters(['allFlags']),
    ...mapRatePlanFields(['message']),
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: 'WholesalerName',
        field: 'wholesalerName',
        sort: 'desc',
      },
      {
        headerName: 'Name',
        field: 'name',
      },

      {
        headerName: 'GroupNO',
        field: 'groupNo',
      },
      {
        headerName: 'CustNo',
        field: 'custNo',
      },
      {
        headerName: 'Summary',
        field: 'summaryNotification',

        cellRenderer: function(params) {
          var input = document.createElement('input');
          input.type = 'checkbox';
          input.checked = params.value;
          input.addEventListener('click', function(event) {
            params.value = !params.value;
            params.node.data.fieldName = params.value;
          });
          return input;
        },
      },
      {
        headerName: 'Individual',
        field: 'individualNotification',

        cellRenderer: function(params) {
          var input = document.createElement('input');
          input.type = 'checkbox';
          input.checked = params.value;
          input.addEventListener('click', function(event) {
            params.value = !params.value;
            params.node.data.fieldName = params.value;
          });
          return input;
        },
      },
      {
        headerName: 'Group',
        field: 'groupNotification',

        cellRenderer: function(params) {
          var input = document.createElement('input');
          input.type = 'checkbox';
          input.checked = params.value;
          input.addEventListener('click', function(event) {
            params.value = !params.value;
            params.node.data.fieldName = params.value;
          });
          return input;
        },
      },
    ];
  },
  methods: {
    async getData() {
      let vm = this;
      let contacts = await HTTP.get('oms/ListDataUsageContacts');
      HTTP.get('oms/ListWholesalers/1').then(data => {
        vm.rowData = data.data;
        vm.rowData.forEach(x => {
          if (x.usageWholesalerContact !== 0) {
            x.wholesalerName = contacts.data.find(
              y => y.id == x.usageWholesalerContact
            ).wholesaleName;
          }
        });
      });
    },
    async onGridReady(params) {
      this.gridApi = params.api;
      await this.getData();

      this.gridApi.sizeColumnsToFit();
    },
    getSelectedRows(params) {
      let vm = this;
      const selectedData = vm.gridApi.getSelectedRows();
      vm.selected = selectedData[0];
      this.dialog = true;
    },
    onSaved(val) {
      this.dialog = false;
      this.getData();
    },
  },
};
</script>

<style scoped></style>
